const API_ERROR_CODE_RESULT_INDEX = 2; // expected error code format: xx.xx.xxx

export const isSuccessCode = (errorCode: string): boolean => {
    return (errorCode ?? "").split(".")[API_ERROR_CODE_RESULT_INDEX]?.startsWith("0") || false;
};
